<script>
  import { debounce, handleViewportSize } from '@/lib/vue-helpers.js';
  import { emitter } from '@/main.js';
  import ProductListItem from '@/components/ProductListItem.vue';
  import ProductListPromo from '@/components/ProductListPromo.vue';
  import { Carousel, Slide, Navigation } from 'vue3-carousel';
  import { getProductMetafieldFromFS, getProductCollectionMetafieldFromFS } from '@/lib/vue-helpers.js';
  import 'vue3-carousel/dist/carousel.css';
  import { whenFastSimonReady, ReportRecommendationView, logFastSimonError } from '@/lib/vue-helpers.js';

  export default {
    name: 'ProductRecommendations',
    components: {
      ProductListItem,
      ProductListPromo,
      Carousel,
      Slide,
      Navigation
    },
    props: {
      pid: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        localPid: this.pid,
        carouselCount: 0,
        carouselCountMatch: false,
        currentSlide: 0,
        isGrid: false,
        maxProductsForGrid: 0,
        gridDesktop: 5,
        gridMobile: 1.2,
        gridTablet: 3,
        product_type: '',
        holderItems: [],
        itemsToScroll: 1,
        itemsToShow: 1.2,
        productImageName: '',
        productReommendationProducts: [],
        productsOnDisplay: [],
        scrollbar: '',
        scrollbarHide: 'hide',
        scrollbarNumLoaded: 0,
        scrollbarTrack: '',
        scrollbarWidth: '',
        selectedFilter: 'product-recommendation',
        slideNextBtn: '',
        slidePrevBtn: '',
        slidesCount: 0,
        titleHeading: '',
        trackWidth: '',
        default_title: '',
        arrow_left_image: '',
        arrow_left_image_alt: '',
        arrow_left_image_width: '',
        arrow_left_image_height: '',
        arrow_left_image_disabled: '',
        arrow_left_image_disabled_alt: '',
        arrow_left_image_disabled_width: '',
        arrow_left_image_disabled_height: '',
        arrow_custom_on: false,
        arrow_custom_off: false,
        onScreen: false,
        productCategoryMetafieldOneAttr: '',
        productCategoryMetafieldTwoAttr: '',
        productCategoryMetafieldOneCollectionAttr: '',
        productCategoryMetafieldTwoCollectionAttr: '',
        productReminderMetafieldEmbedAttr: '',
        setReminderLinkText: window.siteGlobals.set_reminder_link_text,
        FS_Widget_Id_Placement_1: '',
        FS_Widget_Title_1: '',
        FS_Widget_Id_Placement_2: '',
        FS_Widget_Title_2: '',
        FS_Widget_Id_Placement_3: '',
        FS_Widget_Title_3: '',
        FS_Widget_Id_Placement_4: '',
        FS_Widget_Title_4: '',
        FS_Widget_Id_Placement_5: '',
        FS_Widget_Title_5: '',
        FS_Product_Data: {},
        defaultFSWidgetId: '',
        showWidget: false,
        showTabs: false,
        minProductsToShow: '',
        showCrosssellPercentage: 'false',
        useFsProductData: '',
        hideSwatches: true,
        disableSlider: false,
        isLoadingTab: false,
        bottomPillBadgePadding: 0,
        tabsPill: false,
        stackedOnLeft: false
      };
    },
    computed: {
      hasWidgetsWithProducts() {
        return Object.values(this.FS_Product_Data).some(widget => widget.products && widget.products.length > 0);
      },
      isMobile() {
        return window.innerWidth <= window.theme.sizes.medium;
      }
    },
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      this.gridDesktop = this.$el.parentElement.getAttribute('data-grid-desktop');
      this.gridMobile = this.$el.parentElement.getAttribute('data-grid-mobile');
      this.minProductsToShow = this.$el.parentElement.getAttribute('data-min-products-to-show');
      this.gridTablet = this.$el.parentElement.getAttribute('data-grid-tablet') ? this.$el.parentElement.getAttribute('data-grid-tablet') : this.gridTablet;
      this.productCategoryMetafieldOneAttr = window.siteGlobals.product_cat_metafield_one || '';
      this.productCategoryMetafieldTwoAttr = window.siteGlobals.product_cat_metafield_two || '';
      this.productCategoryMetafieldOneCollectionAttr = window.siteGlobals.product_cat_metafield_one_collection || '';
      this.productCategoryMetafieldTwoCollectionAttr = window.siteGlobals.product_cat_metafield_two_collection || '';
      this.productReminderMetafieldEmbedAttr = window.siteGlobals.set_reminder_metafield;
      this.productImageName = this.$el.parentElement.getAttribute('data-product_swatch_name');
      this.product_type = this.$el.parentElement.getAttribute('data-product_type');
      this.titleHeading = this.$el.parentElement.getAttribute('data-title');
      this.default_title = this.$el.parentElement.getAttribute('data-default_title');
      this.arrow_custom_on = this.$el.parentElement.getAttribute('data-arrow_custom_on') === 'true';
      this.arrow_custom_off = this.$el.parentElement.getAttribute('data-arrow_custom_off');
      this.showTabs = this.$el.parentElement.dataset.showTabs === 'true';
      this.isGrid = this.$el.parentElement.dataset.isGrid === 'true';
      this.maxProductsForGrid = parseInt(this.$el.parentElement.dataset.maxProductsForGrid);
      this.tabsPill = this.$el.parentElement.dataset.tabsPill === 'true';
      this.stackedOnLeft = this.$el.parentElement.dataset.stackedOnLeft === 'true';
      this.showCrosssellPercentage = this.$el.parentElement.getAttribute('data-show-crosssell-percentage') || 'false';
      const useFsProductDataAttr = this.$el.parentElement.getAttribute('data-use-fs-product-data') || this.$el.parentElement.getAttribute('data-use_fs_product_data');
      this.useFsProductData = useFsProductDataAttr === 'true' ? 'true' : '';
      const hideSwatchesAttr = this.$el.parentElement.getAttribute('data-hide-swatches');
      this.hideSwatches = hideSwatchesAttr === 'false' ? false : true;
      const disableSliderAttr = this.$el.parentElement.getAttribute('data-disable-slider');
      this.disableSlider = disableSliderAttr === 'true';

      this.currentSlide = 0;
      this.slidesCount = 0;
      // Set arrow image variables in a loop
      const arrowProperties = ['arrow_left_image', 'arrow_left_image_alt', 'arrow_left_image_width', 'arrow_left_image_height', 'arrow_left_image_disabled', 'arrow_left_image_disabled_alt', 'arrow_left_image_disabled_width', 'arrow_left_image_disabled_height'];
      arrowProperties.forEach(prop => {
        this[prop] = this.$el.parentElement.getAttribute(`data-${prop}`);
      });
      // Set FS Widget variables in a loop
      for (let i = 1; i <= 5; i++) {
        this[`FS_Widget_Id_Placement_${i}`] = this.$el.parentElement.getAttribute(`data-FS_Widget_Id_Placement_${i}`);
        this[`FS_Widget_Title_${i}`] = this.$el.parentElement.getAttribute(`data-FS_Widget_Title_${i}`);
        let currentSlideId = this[`FS_Widget_Id_Placement_${i}`];
        let currentTitle = this[`FS_Widget_Title_${i}`];
        if (currentSlideId != '' && currentSlideId != null) {
          this.FS_Product_Data[currentSlideId] = {
            title: currentTitle,
            products: []
          };
        }
      }
      this.delayGetProductRecs();
      emitter.on('pdp-tags-updated', e => {
        if (this.localPid != e.pid) {
          this.localPid = e.pid;
          this.productsOnDisplay = [];
          this.delayGetProductRecs();
        }
      });
      emitter.on('bundle-child-handle-updated', ({ handle }) => {
        this.resetRecommendations();
        this.fetchProductIdFromHandle(handle);
      });
      emitter.on('bundled-product-selected', ({ handle }) => {
        this.resetRecommendations();
        this.fetchProductIdFromHandle(handle);
      });

      window.addEventListener('resize', () => {
        debounce(this.getClientWidth());
      });
      this.getClientWidth();
    },
    unmounted() {
      if (this.handleViewportSize) this.handleViewportSize();
    },
    methods: {
      delayGetProductRecs() {
        setTimeout(() => {
          this.getProductRecs();
        }, 1000);
        this.getClientWidth();
      },

      resetFsProductData() {
        Object.keys(this.FS_Product_Data).forEach(key => {
          const widget = this.FS_Product_Data[key];
          if (widget && widget.products) {
            widget.products = [];
          }
        });
      },

      resetRecommendations() {
        this.productsOnDisplay = [];
        this.productReommendationProducts = [];
        this.scrollbarNumLoaded = 0;
        this.showWidget = false;
        this.isLoadingTab = true;
        this.resetSlideShow();
        this.resetFsProductData();
      },

      resetSlideShow() {
        this.currentSlide = 0;
        if (this.slidePrevBtn !== '') {
          this.slidePrevBtn?.setAttribute('disabled', 'disabled');
          this.slidePrevBtnCustom?.setAttribute('disabled', 'disabled');
        }
        if (this.slideNextBtn !== '') {
          this.slideNextBtn?.removeAttribute('disabled');
          this.slideNextBtnCustom?.removeAttribute('disabled');
        }
      },
      async fetchProductIdFromHandle(handle) {
        if (!handle) {
          return;
        }
        try {
          const response = await fetch(`/products/${handle}.json`);
          if (!response.ok) {
            throw new Error(`Failed to fetch product for handle ${handle}`);
          }
          const data = await response.json();
          const productId = data?.product?.id ? data.product.id.toString() : null;
          if (productId) {
            this.localPid = productId;
            this.productsOnDisplay = [];
            this.delayGetProductRecs();
          }
        } catch (error) {
          logFastSimonError(`Error fetching product ID for handle: ${handle}`, error);
          this.showWidget = false;
          this.productsOnDisplay = [];
          this.productReommendationProducts = [];
          this.isLoadingTab = false;
        }
      },

      isSelected(filter) {
        if (filter === this.selectedFilter) {
          return 'current tab-link gt-p__bold';
        } else {
          return 'tab-link gt-p';
        }
      },
      getClientWidth() {
        const width = window.innerWidth;
        if (width <= window.theme.sizes.medium) {
          this.itemsToShow = Number(this.gridMobile);
          this.itemsToScroll = Number(this.gridDesktop);
        } else if (width > window.theme.sizes.medium && width <= window.theme.sizes.large) {
          this.itemsToShow = Number(this.gridTablet);
          this.itemsToScroll = Number(this.gridTablet);
        } else if (width > window.theme.sizes.large) {
          this.itemsToShow = Number(this.gridDesktop);
          this.itemsToScroll = Number(this.gridDesktop);
        }
      },
      slidePrev() {
        const carousel = this.$refs.recommendationCarousel;
        if (!carousel) return;
        const currentSlide = carousel.data.currentSlide;

        if (currentSlide > 0) {
          carousel.prev();
        }

        this.updateNavigationButtons(carousel);
      },
      slideNext() {
        const carousel = this.$refs.recommendationCarousel;
        if (!carousel) return;
        const currentSlide = carousel.data.currentSlide;
        const maxSlide = carousel.data.maxSlide;

        if (currentSlide < maxSlide) {
          carousel.next();
        }
        this.updateNavigationButtons(carousel);
      },
      updateNavigationButtons(carousel) {
        if (!carousel) return;

        const currentSlide = carousel.data.currentSlide;
        const maxSlide = carousel.data.maxSlide;

        this.slidePrevBtn.disabled = currentSlide === 0;
        this.slideNextBtn.disabled = currentSlide === maxSlide;
        this.slidePrevBtnCustom.disabled = currentSlide === 0;
        this.slideNextBtnCustom.disabled = currentSlide === maxSlide;
      },
      getRecommendationTitleLabel(tiers) {
        if (!tiers) return null;
        const first = val => (Array.isArray(val) ? val[0] : val);
        const priorityKeys = ['Plytix.color family', 'Custom.color family', 'Isp-color-family', 'Color', 'Isp-tag-Color ( tags)', 'Isp-tag-Color', 'Type', 'Collection'];
        for (const key of priorityKeys) {
          const val = first(tiers[key]);
          if (val) return this.formatRecommendationTitle(val);
        }
        const fallbackKey = Object.keys(tiers)[0];
        if (fallbackKey) return this.formatRecommendationTitle(first(tiers[fallbackKey]));
        return null;
      },
      formatRecommendationTitle(val) {
        if (typeof val !== 'string' || !/^collection-/i.test(val)) return val;
        return val.replace(/^collection-(\w)/i, (_, c) => c.toUpperCase());
      },
      setNavigationButtonContainer() {
        this.$nextTick(() => {
          this.slidePrevBtn = this.$el.parentElement.querySelector('.carousel__prev');
          this.slideNextBtn = this.$el.parentElement.querySelector('.carousel__next');
          this.slidePrevBtnCustom = this.$el.parentElement.querySelector('.custom__arrow--prev');
          this.slideNextBtnCustom = this.$el.parentElement.querySelector('.custom__arrow--next');
        });
      },
      getProductRecs() {
        this.isLoadingTab = true;
        let widgetIds = [];
        for (let i = 1; i <= 5; i++) {
          if (this[`FS_Widget_Id_Placement_${i}`]) {
            widgetIds.push(this[`FS_Widget_Id_Placement_${i}`]);
          }
        }

        // fallback widget id if the first widget has 0 products
        let fallbackWidgetid = '';
        //this.FS_Product_Data = [];
        whenFastSimonReady(() => {
          window.FastSimonSDK.productRecommendationByWidget({
            productID: this.localPid,
            withAttributes: true,
            widgetsIDS: widgetIds,
            callback: response => {
              const prods = response.payload;
              for (let i = 0; i < prods.length; i++) {
                if (prods[i].payload.length > this.minProductsToShow) {
                  if (fallbackWidgetid == '') {
                    fallbackWidgetid = prods[i].widgetID;
                  }
                  this.FS_Product_Data[prods[i].widgetID].products = prods[i].payload;
                  const titleLabel = this.getRecommendationTitleLabel(prods[i].similarByAttributesTiers);
                  if (titleLabel) this.FS_Product_Data[prods[i].widgetID].title = `More ${titleLabel}`;
                }
              }
              // checking for default widget id
              if (this.FS_Product_Data[this.FS_Widget_Id_Placement_1] && this.FS_Product_Data[this.FS_Widget_Id_Placement_1].products.length > 0) {
                this.defaultFSWidgetId = this.FS_Widget_Id_Placement_1;
              } else {
                this.defaultFSWidgetId = fallbackWidgetid;
              }
              if (this.defaultFSWidgetId != '') {
                this.productsOnDisplay = this.FS_Product_Data[this.defaultFSWidgetId].products;
                this.showWidget = true;
                this.selectedFilter = this.defaultFSWidgetId;
                this.setNavigationButtonContainer();
                this.$nextTick(() => {
                  this.resetSlideShow();
                  this.getClientWidth();
                  this.isLoadingTab = false;
                  ReportRecommendationView(this.productsOnDisplay, this.defaultFSWidgetId);
                });
              } else {
                this.showWidget = false;
                this.isLoadingTab = false;
              }
            }
          });
        });
      },
      updateCarouselCount() {
        this.carouselCount++;
        if (this.carouselCount === this.productsOnDisplay.length) {
          this.carouselCountMatch = true;
          this.holderItems = this.$el.parentElement.querySelector('[data-custom-scrollbar-items-free]');
          this.scrollbar = this.$el.parentElement.querySelector('[data-custom-scrollbar-free]');
          this.scrollbarTrack = this.$el.parentElement.querySelector('[data-custom-scrollbar-track-free]');
          if (this.scrollbar && this.holderItems) {
            this.children = this.holderItems.children;
            this.sliderEvents();
            this.sliderCalculateTrackWidth();
          }
        }
      },
      sliderEvents() {
        this.holderItems.addEventListener('scroll', this.sliderCalculatePosition.bind(this));
        this.holderItems.addEventListener('theme:carousel:scroll', this.sliderCalculatePosition.bind(this));
        document.addEventListener('theme:resize:width', this.sliderCalculateTrackWidth.bind(this));
        document.addEventListener('theme:resize:width', this.sliderCalculatePosition.bind(this));
      },
      sliderCalculateTrackWidth() {
        // Javascript can't execute calc() (from `--outer` variable) - create a new div with width property instead `getPropertyValue('--outer')` to can get the width of `after` on the holder
        const htmlObject = document.createElement('div');
        this.holderItems.prepend(htmlObject);
        htmlObject.style.display = 'none';
        htmlObject.style.width = getComputedStyle(this.holderItems).getPropertyValue('--outer');
        const widthAfter = parseInt(getComputedStyle(htmlObject).getPropertyValue('width'));
        this.holderItems.firstChild.remove();
        this.scrollbarWidth = this.scrollbar.clientWidth === 0 ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth;
        const childWidth = this.children[0].clientWidth;
        const childMarginRight = Number(getComputedStyle(this.children[0]).marginRight.replace('px', ''));
        const childMarginLeft = Number(getComputedStyle(this.children[0]).marginLeft.replace('px', ''));
        // Minus `childMarginRight` is added to the end with minus because the last child doesn't have margin-right
        this.scrollWidth = this.children.length * (childWidth + childMarginRight + childMarginLeft) + widthAfter - childMarginRight;
        this.trackWidth = ((this.scrollbarWidth + widthAfter) / this.scrollWidth) * 100;
        this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth;
        this.scrollbar.style.setProperty('--track-width', `${this.trackWidth}%`);
        const hideScrollbar = Math.ceil(this.trackWidth) >= 100;
        this.scrollbar.classList.toggle(this.scrollbarHide.hide, hideScrollbar);
      },
      sliderCalculatePosition() {
        // console.log("sliderCalculatePosition ran");
        let position = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
        position *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth;
        position = position < 0 ? 0 : position;
        position = isNaN(position) ? 0 : position;
        this.scrollbar.style.setProperty('--position', `${Math.round(position)}px`);
        document.dispatchEvent(
          new CustomEvent('theme:scrollbar:scroll', {
            bubbles: true,
            detail: {
              holder: this.holderItems
            }
          })
        );
      },
      handleSlideEnd() {
        const carousel = this.$refs.recommendationCarousel;
        if (!carousel) return;
        const slidesTotal = carousel.data.slidesCount;
        const slidesLeft = slidesTotal - this.currentSlide;
        const disableNext = slidesLeft <= this.itemsToShow;
        const disablePrev = this.currentSlide === 0;
        this.slidePrevBtn.disabled = disablePrev;
        this.slidePrevBtnCustom.disabled = disablePrev;
        this.slideNextBtn.disabled = disableNext;
        this.slideNextBtnCustom.disabled = disableNext;
      },
      showWidgetProducts(widgetId) {
        // Show loading immediately
        this.isLoadingTab = true;
        this.productsOnDisplay = [];
        this.selectedFilter = widgetId;

        // Use requestAnimationFrame to ensure loading state is visible before loading data
        requestAnimationFrame(() => {
          this.$nextTick(() => {
            this.productsOnDisplay = this.FS_Product_Data[widgetId].products;
            ReportRecommendationView(this.productsOnDisplay, widgetId);

            // Wait for ProductListItem components to render
            this.$nextTick(() => {
              // Minimal delay just to ensure DOM has updated
              setTimeout(() => {
                this.isLoadingTab = false;
                this.resetSlideShow();
                this.getClientWidth();
              }, 50);
            });
          });
        });
      },

      reportProductViewRecommendation(productID, index, pid, widgetId) {
        whenFastSimonReady(() => {
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.RecommendationProductClicked,
            data: {
              productID: productID,
              position: index,
              sourceProductID: pid,
              widget_id: widgetId || ''
            }
          });
          window.setFindingMethod('PDP Recommendation:' + this.selectedFilter);
        });
      },
      localGetProductMetafieldOneFromFS(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductMetafieldTwoFromFS(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductCategoryMetafieldOneCollectionFromFS(productList, index, metafieldStr) {
        return getProductCollectionMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductCategoryMetafieldTwoCollectionFromFS(productList, index, metafieldStr) {
        return getProductCollectionMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductReminderEmbedFromFS(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      }
    }
  };
</script>

<template>
  <template v-if="showWidget === true">
    <div class="recommendation-carousel-tabs collection-tabs" :class="[isGrid ? 'recommendation-carousel-grid-tabs' : '', tabsPill ? 'collection-tabs--pill' : '', stackedOnLeft ? 'collection-tabs--stacked-left' : '']">
      <div class="collection-tabs__column">
        <h2 v-html="titleHeading" class="gt-h2 display-inline-block collection-tabs__heading"></h2>

        <div v-if="Object.keys(FS_Product_Data).length > 0 && hasWidgetsWithProducts && showTabs" class="tab__scroll display-inline-block">
          <div class="tabs tabs--center" :class="tabsPill ? 'tabs--pill' : ''">
            <template v-for="(widgetData, widgetId) in FS_Product_Data" :key="widgetId">
              <p v-if="widgetData.products && widgetData.products.length > 0" :class="isSelected(widgetId)" @click="showWidgetProducts(widgetId)" v-html="widgetData.title"></p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading placeholder carousel (desktop only) -->
    <carousel v-if="!isGrid && !isMobile && isLoadingTab" :items-to-scroll="itemsToScroll" :items-to-show="itemsToShow" class="recommendation-carousel placeholder-carousel" snapAlign="start">
      <slide v-for="index in Math.ceil(itemsToShow)" :key="'loading-' + index" class="loading-slide">
        <div class="product-grid-item loading-placeholder">
          <div class="product-image-placeholder"></div>
          <div class="product-title-placeholder"></div>
          <div class="product-price-placeholder"></div>
        </div>
      </slide>
    </carousel>

    <!-- Actual product carousel -->
    <carousel
      :items-to-scroll="itemsToScroll"
      :items-to-show="itemsToShow"
      @slide-end="handleSlideEnd"
      class="recommendation-carousel product-carousel"
      id="pdp-recommendations-carousel"
      ref="recommendationCarousel"
      snapAlign="start"
      v-if="productsOnDisplay.length && !isGrid"
      :class="{
        'is-visible': !isLoadingTab
      }"
      v-model="currentSlide"
    >
      <template #addons>
        <Navigation />
      </template>
      <slide v-for="(product, index) in productsOnDisplay" :key="product + '-' + index + product.id" :pid="product.id">
        <ProductListItem :hideSwatches="hideSwatches" :disableSlider="disableSlider" :key="'grid' + product + '-' + index + '-' + useFsProductData" :fsData="useFsProductData === 'true' ? product : null" :useFsProductData="useFsProductData" :pid="product.id" :productImageName="productImageName" :productTitle="product.l" :productCategoryMetafieldOne="localGetProductMetafieldOneFromFS(productsOnDisplay, index, productCategoryMetafieldOneAttr)" :productCategoryMetafieldTwo="localGetProductMetafieldTwoFromFS(productsOnDisplay, index, productCategoryMetafieldTwoAttr)" :productCategoryMetafieldOneCollection="localGetProductCategoryMetafieldOneCollectionFromFS(productsOnDisplay, index, productCategoryMetafieldOneCollectionAttr)" :productCategoryMetafieldTwoCollection="localGetProductCategoryMetafieldTwoCollectionFromFS(productsOnDisplay, index, productCategoryMetafieldTwoCollectionAttr)" :productReminderMetafieldEmbed="localGetProductReminderEmbedFromFS(productsOnDisplay, index, productReminderMetafieldEmbedAttr)" @click="reportProductViewRecommendation(product.id, index, localPid, selectedFilter || '')" v-if="product.l" :setReminderLinkText="setReminderLinkText" :showSalePercentage="showCrosssellPercentage === 'true'" :fsWidgetId="selectedFilter" :fsProductPosition="index + 1"> </ProductListItem>
        <ProductListPromo :Image="product.image" :Link="product.link" :Title="product.title" v-if="product.promotile"> </ProductListPromo>
      </slide>
    </carousel>

    <!-- Loading placeholder for grid/freescroll (mobile or grid mode) -->
    <div v-if="isLoadingTab && (isMobile || isGrid)" class="recommendation-freescroll loading-placeholder-container" :class="{ 'recommendation-grid': isGrid }">
      <div class="freescroll-track loading-freescroll-track" :class="{ 'grid-list-items': isGrid }" data-custom-scrollbar-items-free>
        <div v-for="index in Math.ceil(itemsToShow)" :key="'loading-freescroll-' + index" class="freescroll__slide" :class="isGrid ? 'product-grid-item-wrapper' : ''">
          <div class="product-grid-item loading-placeholder">
            <div class="product-image-placeholder"></div>
            <div class="product-title-placeholder"></div>
            <div class="product-price-placeholder"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Actual product grid/freescroll -->
    <div :class="isGrid ? 'recommendation-grid' : 'recommendation-freescroll'" v-show="!isLoadingTab">
      <div :class="isGrid ? 'grid-list-items' : 'freescroll-track'" data-custom-scrollbar-items-free>
        <div v-for="(product, index) in productsOnDisplay" :key="product + '-' + index + product.id + '-freescroll'" :pid="product.id + '-freescroll'" class="freescroll__slide" :class="isGrid ? 'product-grid-item-wrapper' : ''">
          <ProductListItem :hideSwatches="hideSwatches" :disableSlider="disableSlider" :key="'grid' + product + '-' + index + '-' + useFsProductData" :fsData="useFsProductData === 'true' ? product : null" :useFsProductData="useFsProductData" :pid="product.id" :productImageName="productImageName" :productTitle="product.l" :productCategoryMetafieldOne="localGetProductMetafieldOneFromFS(productsOnDisplay, index, productCategoryMetafieldOneAttr)" :productCategoryMetafieldTwo="localGetProductMetafieldTwoFromFS(productsOnDisplay, index, productCategoryMetafieldTwoAttr)" :productCategoryMetafieldOneCollection="localGetProductCategoryMetafieldOneCollectionFromFS(productsOnDisplay, index, productCategoryMetafieldOneCollectionAttr)" :productCategoryMetafieldTwoCollection="localGetProductCategoryMetafieldTwoCollectionFromFS(productsOnDisplay, index, productCategoryMetafieldTwoCollectionAttr)" :isGrid="isGrid" @click="reportProductViewRecommendation(product.id, index, localPid, selectedFilter || '')" @countCarouselsLoaded="updateCarouselCount" v-if="product.l" :setReminderLinkText="setReminderLinkText" :showSalePercentage="showCrosssellPercentage === 'true'" :fsWidgetId="selectedFilter" :fsProductPosition="index + 1"></ProductListItem>
          <ProductListPromo :Title="product.title" :Image="product.image" :Link="product.link" v-if="product.promotile"> </ProductListPromo>
        </div>
      </div>
    </div>

    <!-- Adapt data-carousel-track code from theme.dev.js -->
    <div class="custom-scrollbar-free small-down--show small-up--hide" data-custom-scrollbar-free v-show="carouselCountMatch && !isLoadingTab">
      <div class="custom-scrollbar-free__track" data-custom-scrollbar-track-free></div>
    </div>

    <div v-if="!isGrid && !isLoadingTab" class="recommendation-carousel-custom-btns">
      <!-- Default navigation -->
      <button @click="slidePrev" class="carousel__prev" :class="arrow_custom_on ? 'is-hidden' : ''" type="button" aria-label="Previous" disabled="disabled">
        <svg class="flickity-button-icon" viewBox="0 0 100 100">
          <title>Previous</title>
          <path
            d="M 10, 50
          L 60, 100
          L 75, 90
          L 35, 50
          L 75, 10
          L 60, 0
          Z"
            class="arrow"
          ></path>
        </svg>
      </button>
      <button @click="slideNext" class="carousel__next" :class="arrow_custom_on ? 'is-hidden' : ''" type="button" aria-label="Next">
        <svg class="flickity-button-icon" viewBox="0 0 100 100">
          <title>Next</title>
          <path
            d="M 10, 50
          L 60, 100
          L 75, 90
          L 35, 50
          L 75, 10
          L 60, 0
          Z"
            class="arrow"
            transform="translate(100, 100) rotate(180)"
          ></path>
        </svg>
      </button>
      <!-- Custom arrow navigation -->
      <button @click="slidePrev" class="tabs__arrow--custom custom__arrow--prev" aria-label="Previous" :class="arrow_custom_on ? '' : 'is-hidden'">
        <img class="enabled" :src="arrow_left_image" :alt="arrow_left_image_alt" :width="arrow_left_image_width" :height="arrow_left_image_height" />
        <img class="disabled" :src="arrow_left_image_disabled" :alt="arrow_left_image_disabled_alt" :width="arrow_left_image_disabled_width" :height="arrow_left_image_disabled_height" />
      </button>
      <button @click="slideNext" class="tabs__arrow--custom custom__arrow--next" aria-label="Next" :class="arrow_custom_on ? '' : 'is-hidden'">
        <img class="enabled" :src="arrow_left_image" :alt="arrow_left_image_alt" :width="arrow_left_image_width" :height="arrow_left_image_height" />
        <img class="disabled" :src="arrow_left_image_disabled" :alt="arrow_left_image_disabled_alt" :width="arrow_left_image_disabled_width" :height="arrow_left_image_disabled_height" />
      </button>
    </div>
  </template>
</template>

<style lang="scss">
  @keyframes placeholderShimmer {
    0% {
      transform: translateX(-100%) rotate(32deg);
    }
    100% {
      transform: translateX(100%) rotate(8deg);
    }
  }

  .pdp-recommendations-wrapper {
    min-height: 380px;
    transition: all 0.3s ease-out;
    position: relative;
    max-width: var(--LAYOUT-WIDTH);
    margin: 0 auto 1.25rem auto;
    padding: 0;

    .is-tablet &,
    .is-desktop & {
      padding: 0 var(--outer) 0 var(--outer);
    }
  }

  #pdp-recommendations {
    overflow: hidden;
    position: relative;

    .is-tablet &,
    .is-desktop & {
      margin: 0 auto;
      max-width: var(--LAYOUT-WIDTH);
      padding-left: 0;
      padding-right: 0;
    }

    // PDP Recommendations - Carousel - Main
    .recommendation-carousel {
      width: 100%;
      max-width: var(--LAYOUT-WIDTH);
      margin-top: 12px;
      transition: opacity 0.3s ease;

      .is-mobile & {
        display: none;
      }

      * {
        box-sizing: border-box;
      }

      // Placeholder carousel (loading state)
      &.placeholder-carousel {
        opacity: 1;
        z-index: 2;
        position: relative;
        min-height: var(--vc-trk-height, auto);
        height: 100%;
        transition:
          opacity 0.15s ease,
          height 0.15s ease;

        .is-mobile & {
          display: block;
        }

        &.is-hidden {
          height: 0;
          opacity: 0;
          pointer-events: none;
          overflow: hidden;
        }
      }

      // Actual product carousel
      &.product-carousel {
        height: 0;
        opacity: 0;
        z-index: 1;
        visibility: visible !important;
        transition:
          opacity 0.15s ease,
          height 0.15s ease;

        &.is-visible {
          height: 100%;
          opacity: 1;
        }
      }
    }

    .carousel__viewport {
      overflow: hidden;
    }

    .carousel__track {
      display: flex;
      margin: 0 !important;
      position: relative;

      .carousel__track {
        padding: 0 !important;
      }
    }

    .carousel__slide {
      scroll-snap-stop: normal;
      flex-shrink: 0;
      margin: 0;
      padding: 0;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      transform: translateZ(0);

      .is-mobile & {
        &:not(.recommendation-grid *) {
          padding-right: var(--gutter);
        }
      }

      .carousel__slide {
        .is-mobile & {
          padding-left: 0;
          padding-right: 0;
        }
      }

      > img {
        object-position: center center;
        aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);

        .is-mobile & {
          height: 100%;
          width: 100%;
          overflow: hidden;
          object-fit: cover;
        }
      }

      .product-grid-item {
        width: 100%;
        padding: 0 calc(var(--gutter) / 2);

        .is-mobile & {
          padding: 0;
        }
      }

      .product-grid-item > div {
        width: 100%;
      }
    }

    .carousel.is-dragging .product-grid-item__image-link,
    .carousel.is-sliding .product-grid-item__image-link {
      pointer-events: none;
      touch-action: none;
    }

    .is-mobile & {
      .carousel.is-hover .carousel .product-grid-item__image-link {
        pointer-events: none;
      }
    }

    // Copied from CollectionProducts.vue
    .js-grid div:not(.loader):empty {
      display: none;
    }

    .promo-wrapper .isNoResults {
      margin-top: 20px;
      margin-bottom: 20px;

      .suggestions {
        text-transform: none;
        margin-top: 20px;
      }
    }

    .js-grid {
      column-gap: 15px;
      row-gap: 30px;
    }

    .collection__text-content.wrapper.section-padding {
      padding-left: var(--outer);
      padding-right: var(--outer);
      width: 100%;
      max-width: 100%;
    }

    .is-mobile & {
      .collection .wrapper--full.section-padding {
        padding-left: 0;
        padding-right: 0;
      }
    }

    // PDP Recommendations - Carousel - Navigation
    .hide-me {
      opacity: 0;
    }

    .hide-me-false {
      .carousel__prev,
      .carousel__next {
        opacity: 1;
        // Re-enable pointer events on hover so users can use the arrows.
        pointer-events: auto;
      }

      .carousel__pagination {
        opacity: 1;
        // Pagination dots are visual-only (buttons are display:none below);
        // keep pointer-events disabled so clicks pass through to the
        // underlying image link.
      }
    }

    .hide-me-true:not(.show-pagination-dots) {
      .carousel__pagination,
      .carousel__prev,
      .carousel__next {
        opacity: 0;
        // Invisible at rest; ensure they don't swallow clicks on the
        // underlying image link before hover reveals them.
        pointer-events: none;
      }
    }

    .product-grid-item__content.show-pagination-dots .product-image-carousel .carousel__pagination {
      opacity: 1;
      visibility: visible;
      display: flex;
      pointer-events: none;
    }

    .is-mobile & {
      .product-grid-item__content.show-pagination-dots .product-image-carousel .carousel__pagination {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }
    }

    .carousel__prev,
    .carousel__next {
      position: absolute;
      top: auto;
      bottom: 100%;
      // Copy from Flickity button
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: none;
      color: var(--text);
      transition: all 0.3s;
      background: white;
      border: 1px solid black;
      border-radius: 0;
      transform: none;

      .is-tablet & {
        --padding-top: calc(var(--PT) * 0.8);
        --padding-bottom: calc(var(--PB) * 0.8);
      }

      .is-mobile & {
        display: none;
      }

      svg {
        position: absolute;
        left: 33%;
        top: 33%;
        width: 35%;
        height: 35%;
        fill: currentColor;
      }
    }

    .carousel__next {
      img {
        transform: rotate(180deg);
      }
    }

    .recommendation-freescroll {
      width: 100%;
      max-width: var(--LAYOUT-WIDTH);
      margin: 19px auto 0 auto;
      touch-action: pan-x;
      pointer-events: all;

      .is-tablet &,
      .is-desktop & {
        display: none;
      }

      .freescroll-track {
        display: flex;
        flex-flow: row nowrap !important;
        margin: 0 var(--outer-offset);
        overflow: hidden;
        overflow-x: scroll;
        -ms-overflow-style: none;
        position: relative;
        scroll-behavior: smooth;
        scroll-padding: var(--outer);
        scroll-snap-type: x mandatory;
        scrollbar-color: var(--border) var(--bg-accent);
        width: calc(100% + var(--outer) * 2);
        padding-left: var(--outer);
        padding-right: 0;

        > div {
          flex: 0 0 auto;
          position: relative;
          overflow: hidden;
          padding: 0;
          margin-left: 0;
          margin-right: var(--gutter);
          width: 86%;
          width: calc((100% - var(--outer) * 2) / var(--grid-small-items) - var(--gutter) / var(--grid-small-items) * (var(--grid-small-items) - 1));
        }

        .carousel__slide {
          padding: 0;
          overflow-x: scroll;
        }

        img {
          pointer-events: none;
        }
      }

      .product__grid__title {
        margin-top: 0;
      }

      .product-grid-item__container {
        aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
        object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
      }
    }

    // Ensure loading placeholder on mobile always uses freescroll layout
    .loading-placeholder-container {
      .is-mobile & {
        .freescroll-track {
          display: flex !important;
          flex-flow: row nowrap !important;
        }

        // Override grid-list-items on mobile for loading placeholder
        .grid-list-items {
          display: flex !important;
          flex-flow: row nowrap !important;
          gap: 0;
        }
      }
    }

    .recommendation-grid {
      padding: var(--outer) 0;

      .product-grid-item-wrapper {
        padding: 0 calc(var(--gutter) / 2);

        .is-mobile & {
          &:nth-child(odd) {
            padding-left: 0;
            padding-right: calc(var(--gutter) / 2);
          }
          &:nth-child(even) {
            padding-right: 0;
            padding-left: calc(var(--gutter) / 2);
          }
        }
      }

      .grid-list-items {
        display: grid;
        gap: var(--outer) 0;

        @media only screen and (min-width: 1100px) {
          grid-template-columns: repeat(v-bind(gridDesktop), 1fr);
        }

        .is-tablet & {
          grid-template-columns: repeat(v-bind(gridTablet), 1fr);
        }

        .is-mobile & {
          grid-template-columns: repeat(v-bind(gridMobile), 1fr);
        }
      }
    }

    // Slider navigation
    .carousel__pagination {
      // Pagination dots are visual-only here (buttons are display:none);
      // disabling pointer-events prevents the pagination overlay from
      // swallowing clicks on the underlying product image link.
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 5px;
      right: 5px;
      z-index: 1;
      transition: opacity 0.2s linear;
      transform: none;
      margin: 10px 0 0 !important;
    }

    .is-tablet & {
      .carousel__pagination {
        top: 3px;
        margin-top: 5px;
      }
    }

    .is-mobile & {
      .carousel__pagination {
        top: 0px;
        margin-top: 5px;
      }
    }

    .carousel__pagination-item {
      width: 20px;
      height: 1px;
      display: inline-block;
      border: 0;
      margin: 0 4px 0.25em 4px;
      padding: 0;
      cursor: pointer;
      padding: var(--vc-pgn-margin);
      background: transparent;
      flex-grow: unset;
      border-radius: 0;
    }

    .is-tablet &,
    .is-desktop & {
      .carousel__pagination-item {
        top: 0px;
        padding-top: 0;
      }
    }

    .carousel__pagination-item::before {
      content: none;
    }

    .carousel__pagination-button::after {
      display: block;
      content: '';
      border-radius: var(--vc-pgn-border-radius);
      width: 20px;
      height: 1px;
      background-color: var(--vc-pgn-background-color);
    }

    .carousel__pagination-button.carousel__pagination-button--active::after {
      width: 20px;
      height: 1px;
      background-color: var(--vc-pgn-active-color);
    }

    // Loading placeholder styles
    .loading-placeholder {
      width: 100%;

      .product-image-placeholder,
      .product-title-placeholder,
      .product-price-placeholder {
        position: relative;
        background-color: var(--hairline, #f6f6f6);
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: -30%;
          width: 200%;
          height: 200%;
          background: linear-gradient(to right, transparent 16%, var(--bg) 32%, transparent 48%);
          animation: placeholderShimmer 2.4s linear infinite;
          transform-origin: center;
          pointer-events: none;
          transform: translateX(-100%) rotate(32deg);
          z-index: 1;
        }
      }

      .product-image-placeholder {
        width: 100%;
        aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
        margin-bottom: 1rem;
      }

      .product-title-placeholder {
        height: 20px;
        width: 80%;
        margin-bottom: 0.5rem;
      }

      .product-price-placeholder {
        height: 14px;
        width: 40%;
      }
    }
  }
</style>
